import { createUseStyles } from 'react-jss';
import { Theme } from '@mui/material';

export const useStyles = createUseStyles((theme: Theme) => ({
    form: { display: 'flex', flexDirection: 'column', gap: 14, paddingTop: 6 },
    dates: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        gap: 12,
        [theme.custom.mq.xs]: { gridTemplateColumns: '1fr' },
    },
}));
